<template>
	<div class="goods-form-wrapper">
		<div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left">
				<!--{{ $t('Create goods') }}-->
				{{ $t('goods.create.title') }}
			</h4>
			<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i
				class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>

		<form v-on:submit="create">

			<select-or-create
				v-if="companyType !== 'SHOP'"
				v-model="dropdowns.category"
				:options="getRefChildren"
				name="category"
				v-validate="validators.category"
				:states="validationFields.category"
				:required="validators.category.required"
				:parent-name="'Category'"
				@not-close="parentClose($event)"
				:parent-code="'WAREHOUSE_CATEGORY'"
				:label="$t('goods.create.category')"
				@reload="getReferenceChildren('WAREHOUSE_CATEGORY')"
			></select-or-create>
			<select-or-create
				v-model="dropdowns.subcategory.value"
				:options="dropdowns.subcategory.items"
        v-validate="validators.subcategory"
        :states="validationFields.subcategory"
        :required="validators.subcategory.required"
				:parent-name=" companyType !== 'SHOP' ? $t('goods.create.select-subcategory') : $t('Группа') "
				@not-close="parentClose($event)"
				:parent-code="dropdowns.categoryCode"
				:label=" companyType !== 'SHOP' ? $t('goods.create.select-subcategory') : $t('incomes.block-counteragent.group') "
				:disabled="!dropdowns.categoryCode"
				@reload="loadSubCategory(dropdowns.category)"
			></select-or-create>

			<select-or-create
				v-model="dropdowns.subsubcategory.value"
				:options="dropdowns.subsubcategory.items"
        v-validate="validators.subsubcategory"
        :states="validationFields.subsubcategory"
        :required="validators.subsubcategory.required"
				:parent-name=" companyType !== 'SHOP' ? $t('goods.create.select-subcategory') : $t('Категория') "
				@not-close="parentClose($event)"
				:parent-code="dropdowns.subCategoryCode"
				:label=" companyType !== 'SHOP' ? $t('goods.create.select-subcategory') : $t('goods.category') "
				:disabled="!dropdowns.subCategoryCode"
				@reload="loadSubSubCategory(dropdowns.subcategory.value)"
			></select-or-create>

			<select-or-create
				v-model="dropdowns.sub3category.value"
				:options="dropdowns.sub3category.items"
				:parent-name=" companyType !== 'SHOP' ? $t('goods.create.select-subcategory') : $t('Подкатегория') "
				@not-close="parentClose($event)"
				:parent-code="dropdowns.sub2CategoryCode"
				:label=" companyType !== 'SHOP' ? $t('goods.create.select-subcategory') : $t('goods.subcategory') "
				:disabled="!dropdowns.sub2CategoryCode"
				@reload="loadSub3Category(dropdowns.subsubcategory.value)"
			></select-or-create>

			<b-form-group breakpoint="lg" label-cols="4" label-cols-lg="2" label-size="sm" class="" v-if="$can('list', 'search by keyword')">
				<template slot="label">
					MXIK категория
				</template>
				<multiselect v-model="dropdowns.mxik.value" :options="dropdowns.mxik.items" v-validate="validators.mxik" :required="validators.mxik.required" @search-change="loadMxikCode($event)" :custom-label="mxikCustomLabel" track-by="id" :show-labels="false" :allow-empty="true" placeholder="mxik" class="multiselect-pricing">
					<template slot="option" slot-scope="option">
						{{ mxikCustomLabel(option.option) }}
					</template>
				</multiselect>
			</b-form-group>

			<select-or-create
				:label="$t('goods.create.unit')"
				:options="dropdowns.units"
				v-model="formItems.unitId"
				parent-code="unit"
				parent-name="Unit"
				name="unit"
				v-validate="validators.unit"
				:required="validators.unit.required"
				@reload="loadUnits"
			></select-or-create>

			<!-- WEIGHT IN KG -->
<!--			<b-row v-if="dropdowns.categoryCode === 'MAGAZIN'">-->
<!--				<b-col cols="6">-->
<!--					<b-form-group-->
<!--						breakpoint="lg"-->
<!--						label-cols="2"-->
<!--						label-cols-lg="4"-->
<!--						label-size="sm"-->
<!--						class=""-->
<!--					>-->
<!--						<template slot="label">-->
<!--							{{ $t('goods.weight') }}: ({{ $t('kg') }})-->
<!--						</template>-->
<!--						<b-form-input id="weight"-->
<!--									  size="sm"-->
<!--									  type="number"-->
<!--									  v-model.number="weightKg"-->
<!--									  @input="weightInKgChanged($event)"-->
<!--									  name="material"-->
<!--									  :placeholder="$t('goods.weight') + ' ' + $t('kg')"></b-form-input>-->
<!--					</b-form-group>-->
<!--				</b-col>-->
<!--				<b-col cols="6">-->
<!--					<b-form-group-->
<!--						breakpoint="lg"-->
<!--						label-cols="2"-->
<!--						label-cols-lg="4"-->
<!--						label-size="sm"-->
<!--						class=""-->
<!--					>-->
<!--						<template slot="label">-->
<!--							{{ $t('goods.weight') }}: ({{ $t('gr') }})-->
<!--						</template>-->
<!--						<b-form-input id="weight"-->
<!--									  size="sm"-->
<!--									  type="number"-->
<!--									  v-model.number="formItems.weight"-->
<!--									  @input="weightInGrChanged($event)"-->
<!--									  name="material"-->
<!--									  :placeholder="$t('goods.weight') + ' ' + $t('gr')"></b-form-input>-->
<!--					</b-form-group>-->
<!--				</b-col>-->
<!--			</b-row>-->

<!--			<select-or-create-->
<!--				v-if="companyType === 'SHOP' || dropdowns.categoryCode === 'MAGAZIN'"-->
<!--				:label="$t('goods.create.gender')"-->
<!--				:options="dropdowns.genders"-->
<!--				v-model="formItems.genderId"-->
<!--				parent-code="GENDERS"-->
<!--				parent-name="GENDERS"-->
<!--				name="gender"-->
<!--				v-validate="validators.gender"-->
<!--				@reload="loadGenders"-->
<!--			></select-or-create>-->

			<!--<select-or-create-->
			<!--:label="$t('goods.create.material')"-->
			<!--:options="dropdowns.materials"-->
			<!--v-model="formItems.materialId"-->
			<!--parent-code="MATERIAL"-->
			<!--parent-name="Material"-->
			<!--@reload="loadMaterials"-->
			<!--&gt;</select-or-create>-->
<!--			<b-form-group-->
<!--				breakpoint="lg"-->
<!--				label-cols="4"-->
<!--				label-cols-lg="2"-->
<!--				label-size="sm"-->
<!--				class=""-->
<!--			>-->
<!--				<template slot="label">-->
<!--					{{ $t('goods.create.material') }}-->
<!--				</template>-->
<!--				<b-form-input id="material"-->
<!--							  size="sm"-->
<!--							  v-model="formItems.material"-->
<!--							  name="material"-->
<!--							  :placeholder="$t('goods.create.material')"></b-form-input>-->
<!--			</b-form-group>-->
<!--			<b-form-group-->
<!--				breakpoint="lg"-->
<!--				label-cols="4"-->
<!--				label-cols-lg="2"-->
<!--				label-size="sm"-->
<!--				class=""-->
<!--			>-->
<!--				<template slot="label">-->
<!--					{{ $t('goods.create.structure') }}-->
<!--				</template>-->
<!--				<b-form-input id="structure"-->
<!--							  size="sm"-->
<!--							  v-model="formItems.structure"-->
<!--							  name="material"-->
<!--							  :placeholder="$t('goods.create.structure')"></b-form-input>-->
<!--			</b-form-group>-->
			<b-form-group
				breakpoint="lg"
				label-cols="4"
				label-cols-lg="2"
				label-size="sm"
				class=""
			>
				<template slot="label">
					{{ $t('goods.create.name') }} <span class="text-danger"> * </span>
				</template>
				<b-form-input id="name"
							  size="sm"
							  v-model="formItems.name"
							  name="name"
							  v-validate="validators.name"
							  :placeholder="$t('goods.create.name')"></b-form-input>
			</b-form-group>
			<b-row v-if="dropdowns.categoryCode === 'MAGAZIN'">
				<!--				contragents						-->
				<b-col cols="2">
					<label class="col-form-label  pt-0 col-form-label-sm  pt-0">{{ $t('goods.create.enlightened') }}</label>
				</b-col>
				<b-col cols="4">
					<multiselect v-model="contragentMultple" :options="dropdowns.contragent.items" :multiple="true" :custom-label="contragentSelectedOption" track-by="id" :show-labels="false" :allow-empty="true" :placeholder="$t('goods.create.enlightened')" class="multiselect-pricing"/>
				</b-col>
<!--				<b-col cols="6">-->
<!--					<b-form-group :label="$t('goods.create.size')" breakpoint="lg" label-cols="4" label-cols-lg="4" label-size="sm" class="">-->
<!--						<b-form-input size="sm" id="size" :placeholder="$t('goods.create.size')" v-model="formItems.netContent"/>-->
<!--					</b-form-group>-->
<!--				</b-col>-->
				<b-col cols="6">
					<b-form-group breakpoint="lg" label-cols="4" label="ТНВЭД" label-size="sm" class="">
						<b-form-input size="sm" id="tnved" placeholder="ТНВЭД" v-model="formItems.tnved"></b-form-input>
					</b-form-group>
				</b-col>
<!--				<b-col cols="6">-->
<!--					<select-or-create :label="$t('goods.create.sizeUnit')" :options="dropdowns.units" v-model="formItems.contentUnitId" :label-size="4" :field-size="8" parent-code="unit" parent-name="Unit" name="sizeUnit" @reload="loadUnits"/>-->
<!--				</b-col>-->
<!--				<b-col cols="6">-->
<!--					<select-or-create v-model="dropdowns.brands.value" :options="dropdowns.brands.items" :parent-name="'Brand'" :label-size="4" :field-size="8" @not-close="parentClose($event)" :parent-code="'item_brand'" :label="$t('Brand')" @reload="loadBrands"/>-->
<!--				</b-col>-->
<!--				<b-col cols="6">-->
<!--					<select-or-create v-model="dropdowns.sizeTypes.value" :options="dropdowns.sizeTypes.items" :parent-name="'Size type'" :label-size="4" :field-size="8" @not-close="parentClose($event)" :parent-code="'size_types'" :label="$t('goods.create.sizeType')" @reload="loadSizeTypes"/>-->
<!--				</b-col>-->
<!--				<b-col cols="2">-->
<!--					<label class="col-form-label  pt-0 col-form-label-sm  pt-0">{{ $t('goods.create.color') }}</label>-->
<!--				</b-col>-->
<!--				<b-col cols="4">-->
<!--					<multiselect v-model="dropdowns.colors.value" :options="dropdowns.colors.items" track-by="id" :show-labels="false" :allow-empty="true" label="name" :placeholder="$t('goods.create.color')" class="multiselect-pricing"/>-->
<!--				</b-col>-->
<!--				<b-col cols="6">-->
<!--					<select-or-create v-model="dropdowns.sizesByType.value" :options="dropdowns.sizesByType.items" :label-size="4" :field-size="8" :parent-name="'Sizes by type'" @not-close="parentClose($event)" :parent-code="selectedSizeType.code" :disabled="!dropdowns.sizeTypeCode" :label="$t('goods.create.size')" @reload="loadSizesByType(selectedSizeType.id)"/>-->
<!--				</b-col>-->
				<b-col cols="6">
					<async-input v-model="formItems.barcode" :label="$t('goods.create.special-barcode')" :label-size="4" :field-size="8" name="barcode" v-validate="validators.barcode" :entity-point="'item/generate-barcode'" :full-item="item" :required="true"/>
				</b-col>
<!--				<b-col cols="6">-->
<!--					<select-or-create :label="$t('goods.create.season')" :options="dropdowns.seasons" v-model="formItems.seasonId" :label-size="4" :field-size="8" parent-code="SEASONS" parent-name="SEASONS" name="season" @reload="loadSeasons"/>-->
<!--				</b-col>-->
			</b-row>
			<br>
			<b-row>
				<b-col cols="6" v-for="(artikul, index) in (formItems.vendorCodes?(formItems.vendorCodes.length>0?formItems.vendorCodes:formItems.vendorCodes=[{vendor: ''}]):formItems.vendorCodes=[{vendor: ''}])" :key="`artikuls-${index}`">
					<b-form-group :label="$t('goods.artikul')" breakpoint="lg" label-cols="4" label-cols-lg="4" label-size="sm" size="sm">
						<b-input-group size="sm">
							<b-form-input size="sm" id="artikul" :placeholder="$t('goods.artikul')" v-model="artikul.vendor"/>
							<template #append>
								<b-button v-if="formItems.vendorCodes&&formItems.vendorCodes.length>1" @click="formItems.vendorCodes.splice(index, 1); $forceUpdate()" variant="danger" class="fa fa-minus" size="sm"/>
								<b-button @click="formItems.vendorCodes?(formItems.vendorCodes.push({vendor: ''})):(formItems.vendorCodes=[{vendor: ''}]); $forceUpdate()" variant="success" class="fa fa-plus ml-1" size="sm"/>
							</template>
						</b-input-group>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="2">
					{{ $t('goods.create.barcode') }}
				</b-col>
				<b-col cols="8">
					<b-row v-for="(itm,index) in multiBarcodes">
						<b-col cols="6">
							<async-input class="mb-3"
										 v-model="itm.barcode"
										 name="barcode"
										 :entity-point="'item/generate-barcode'"
										 :full-item="item"
										 :labelSize="0"
							></async-input>
						</b-col>
						<b-col cols="4">
							<b-form-input v-model="itm.ratio" min="1" size="sm" type="number"/>
						</b-col>
						<b-col cols="2">
							<b-button variant="danger" size="sm" @click="removeItemFromTable(index)"
									  v-if="multiBarcodes.length !== 1">
								<i class="fa fa-times"> </i>
							</b-button>
							<b-button variant="success" size="sm" class="ml-2" @click="add"
									  v-if="multiBarcodes.length - 1 === index">
								<i class="fa fa-plus"> </i>
							</b-button>
						</b-col>
					</b-row>
				</b-col>

			</b-row>
			<hr>
			<div class="text-center mb-2">Мин. Макс. значение</div>
			<b-row v-for="(tmp, index) in formItems.minMaxValues" :key="`min-max-${index}`">
				<b-col>
					<multiselect
						label="name"
						track-by="id"
						:multiple="false"
						:allow-empty="true"
						v-model="tmp.depId"
						:group-select="true"
						:show-labels="false"
						:options="departments"
						class="multiselect-pricing"
						@select="setDepId($event, index)"
						:placeholder="$t('promo-to-product.department')"
					/>
				</b-col>
				<b-col>
					<b-form-input
						id="weight"
						size="sm"
						type="number"
						v-model="tmp.minValue"
						name="material"
						placeholder="Мин. знач"
					/>
				</b-col>
				<b-col>
					<b-form-input
						id="weight"
						size="sm"
						type="number"
						v-model="tmp.maxValue"
						name="material"
						placeholder="Мах. знач"
					/>
				</b-col>
				<b-col cols="2">
					<b-button variant="success" size="sm" class="fa fa-plus" @click="formItems.minMaxValues.push({})"/>
					<b-button v-if="formItems.minMaxValues.length>1" variant="danger" size="sm" class="fa fa-minus ml-2" @click="formItems.minMaxValues.splice(index, 1)"/>
				</b-col>
			</b-row>
			<hr>
			<b-row>
				<b-col cols="12" class="openDropdownFrame">
					<b-button class="pull-right" size="sm" v-b-toggle.collapse1 variant="light">
						<i class="fa fa-plus-circle"></i> {{ $t('incomes.create.additional') }}
					</b-button>
				</b-col>
			</b-row>
			<b-collapse id="collapse1" class="mt-2">
				<div class="filter-frame">
					<b-row>
						<b-col cols="6">
							<select-or-create
								v-model="dropdowns.group.value"
								:options="dropdowns.group.items"
								:parent-name="'Group'"
								@not-close="parentClose($event)"
								:parent-code="'item_group'"
								:label="$t('goods.create.select-group')"
								@reload="loadGroups"
							></select-or-create>
						</b-col>
						<b-col cols="6">
							<async-input class="mb-3"
										 v-model="formItems.sku"
										 :label="$t('goods.create.sku')"
										 name="sku"
										 :states="validationFields.sku"
										 :entity-point="'item/generate-sku'"
										 :full-item="item"
							></async-input>
						</b-col>
						<b-col cols="6">
							<select-or-create
								:label="$t('goods.manufacture')"
								:options="dropdowns.providers"
								v-model="formItems.manufacturerId"
								parent-code="providers"
								parent-name="Provider"
								@reload="loadProviders"
							></select-or-create>
						</b-col>
						<b-form-group
							breakpoint="lg"
							label-cols="3"
							label-cols-lg="3"
							:label="$t('goods.create.short-name')"
							label-size="sm"
							class="col-6"
						>
							<template slot="label">
								{{ $t('goods.create.short-name') }}
							</template>

							<b-form-input size="sm" id="shortName"
										  v-model="formItems.shortName"
										  @keypress="shortnameChanged = true"
										  name="shortName"
										  :placeholder="$t('goods.create.short-name')"></b-form-input>
						</b-form-group>
					</b-row>
				</div>
			</b-collapse>
			<b-checkbox v-model="formItems.forPos">{{ $t('goods.create.forPos') }}</b-checkbox>
			<hr>
			<b-row>
				<b-col cols="12">
					<b-checkbox v-model="formItems.wrapped">{{ $t('goods.qop') }}</b-checkbox>
				</b-col>
				<b-col cols="12" v-if="formItems.wrapped">
					<table class="table mt-1 generalTableClass">
						<thead>
						<th>№</th>
						<th>{{ $t('goods.special-barcode') }}</th>
						<th>{{ $t('goods.name') }}</th>
						<th>{{ $t('goods.artikul') }}</th>
						<th>{{ $t('goods.color') }}</th>
						<th>{{ $t('goods.size') }}</th>
						<th>{{ $t('goods.amount') }}</th>
						<th>{{ $t('goods.actions') }}</th>
						</thead>
						<tbody>
						<tr v-for="(wItem,index) in formItems.wrappedItems">
							<td>{{ index + 1 }}</td>
							<td>{{ wItem.barcode }}</td>
							<td>{{ wItem.name }}</td>
							<td>{{ wItem.artikul }}</td>
							<td>{{ wItem.colorName }}</td>
							<td>{{ wItem.sizeName }}</td>
							<td class="w-25">
								<b-form-input type="number" v-model="wItem.amount" @focus="$event.target.select()"></b-form-input>
							</td>
							<td class="table_actions">
								<b-link @click="removeItem(wItem)">
									<i class="fa fa-trash"></i>
								</b-link>
							</td>
						</tr>
						</tbody>
					</table>
				</b-col>
				<b-col v-if="formItems.wrapped">
					<b-button type="button" size="sm" variant="primary" class="mt-1"
							  @click="childModal = !childModal">{{ $t('goods.create.title') }}
					</b-button>
					<b-modal size="lg" hide-footer v-model="childModal">
						<AddChildren
							v-if="childModal"
							@success="wrappedItems"
							:defaults="formItems.wrappedItems"
							:wrappedSearchFormOld="wrappedSearchForm"
							@close="childModal = false"
						></AddChildren>
					</b-modal>
				</b-col>
			</b-row>
			<hr>
			<b-form-group breakpoint="lg"
						  label-cols="2"
						  :label="$t('comment')"
						  label-size="sm">
				<b-textarea v-model="formItems.comment"></b-textarea>
			</b-form-group>

			<div class="modal-actions">
				<b-row class="align-items-center">
					<b-col cols="6" class="mb-3 mb-xl-0">
						<b-row>
							<b-col cols="6">
								<b-button block size="sm" type="button" @click="cancel" variant="outline-danger">{{
										$t('cancel')
									}}
								</b-button>
							</b-col>
							<b-col cols="6">
								<b-button block type="button" size="sm" @click="create" variant="primary">{{
										$t('save')
									}}
								</b-button>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>


		</form>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ReferencesService from "../../../../services/references.sevice";
// import SelectOrCreate from "../../../components/SelectOrCreate";
import AsyncInput from "../../../components/AsyncInput";
import GoodsService from "../../../../services/goods.service";
import AddChildren from "./AddChildren";
import {validators} from "../mixins/validators";
import Multiselect from 'vue-multiselect'
import ContrAgentService from "@/services/contragent.service";
import UsersService from "../../../../services/users.sevice";

export default {
	name: 'CreateModal',
	mixins: [validators],
	props: {
		companyType: {
			type: String,
			default: null
		},
		mode: {
			type: String,
			default: 'create'
		},
		edit: {
			type: Object,
			default: null
		}

	},
	data: () => {
		return {
			contragentMultple: [],
			departments: [],
			isDropped: false,
			shortnameChanged: false,
			item: {
				groupId: '',
				groupName: '',
				shortName: '',
				name: '',
				sku: null,
				categoryId: '',
				categoryName: '',
				subCategoryId: '',
				subCategoryName: '',
				tnved: '',
				mxikCodeId: null,
				barcode: null,
				weight: null,
				brandId: null,
				brandName: '',
				artikul: null,
				model: null,
				size: null,
				colorId: null,
				color: null,
				seasonId: null,
				genderId: null,
				netContent: null,
				minValue: null,
				contentUnitId: null,
				contentUnitName:null,
				maxValue: null,
				manufacturerId: null,
				unitId: null,
				wrapped: false,
				forPos: false,
				comment: null,
				material: null,
				structure: null,
				wrappedItems: [],
				multiBarcodes: [{barcode: '', ratio: 1}],
				minMaxValues: [{departmentId: null, minValue: null, maxValue: null}]
			},
			dropdowns: {
				group: {
					items: [],
					value: null,
				},
				category: null,
				subcategory: {
					items: [],
					value: null
				},
				subsubcategory: {
					items: [],
					value: null
				},
				sub3category: {
					items: [],
					value: null
				},
				mxik: {
					items: [],
					value: null
				},
				brands: {
					items: [],
					value: null
				},
				sizeTypes: {
					items: [],
					value: null
				},
				sizesByType: {
					items: [],
					value: null
				},
				colors: {
					items: [],
					value: null
				},
				contragent: {
					items: [],
					value: null
				},
				categoryCode: null,
				subCategoryCode: null,
				sub2CategoryCode: null,
				sizeTypeCode: null,
				providers: [],
				genders: [],
				units: [],
				materials: [],
				seasons: []
			},
			selectedSizeType: {},
			childModal: false,
			wrappedSearchForm: {
				categoryId: null,
				sub: null,
				sub2: null,
				sub3: null,
				keyword: "",
				genderId: null,
				brandId: null,
				colorId: null
			},
			formItems: [],
			multiBarcodes: [{
				barcode: '',
				ratio: 1
			}],
			weightKg: null
		}
	},
	mounted() {
		if (this.mode === 'edit') {
			this.formItems = this.item.minValue
		}
	},
	async created() {
		this.loadGroups();
		this.loadBrands();
		this.loadSizeTypes();
		this.loadProviders();
		this.loadSeasons()
		this.loadUnits();
		this.loadGenders();
		await this.loadColors();
		await this.loadContragents();
		await this.getReferenceChildren('WAREHOUSE_CATEGORY');
		await this.loadMxikCode();
		this.loadMaterials();
		await UsersService.getPermittedDepartments().then(res => {
			this.departments = res.data.permittedDepartments
		}).catch(e => {
			this.$vs.notify({
				title: e.message,
				color: 'danger',
				icon: 'close',
				position: 'top-right'
			});
		})
		this.setCategoryDefault()
		this.setDefaultValue()
	},
	/**
	 * Methods
	 */
	methods: {
		...mapActions('goods', [
			'createGood'
		]),
		...mapActions('references', [
			'getReferenceChildren'
		]),
		setDepId(tmp, index) {
			this.formItems.minMaxValues[index].departmentId = tmp.id
		},
		mxikCustomLabel(mxik) {
			return (
				mxik.mxikCode +
				" / " +
				mxik.mxikNameRu +
				" / " +
				mxik.classNameRu +
				" / " +
				mxik.groupNameRu +
				" / " +
				mxik.positionNameRu
			);
		},
		add() {
			this.multiBarcodes.push({
				barcode: '',
				ratio: 1
			})
		},
		removeItemFromTable(index) {
			this.multiBarcodes.splice(index, 1);
		},
		weightInKgChanged(e) {
			if (e.trim() == '') {
				this.formItems.weight = null;
			} else {
				this.formItems.weight = e * 1000;
			}
		},
		weightInGrChanged(e) {
			if (e.trim() == '') {
				this.weightKg = null;
			} else {
				this.weightKg = e / 1000;
			}
		},
		async create() {
			this.formItems.contragents = this.contragentMultple
			this.$validator.validate().then(valid => {
				if (valid) {
					this.getRefChildren.filter((category) => {
						if (category.id === this.dropdowns.category) {
							this.formItems.categoryId = category.id;
							this.formItems.categoryName = category.name;
						}
					});

					this.dropdowns.subcategory.items.filter((category) => {
						if (category.id === this.dropdowns.subcategory.value) {
							this.formItems.subCategoryId = category.id;
							this.dropdowns.subCategoryCode = category.code;
						}
					});

					this.dropdowns.subsubcategory.items.filter((category) => {
						if (category.id === this.dropdowns.subsubcategory.value) {
							this.formItems.sub2CategoryId = category.id;
							this.formItems.sub2CategoryName = category.name;
						}
					});
					this.dropdowns.sub3category.items.filter((category) => {
						if (category.id === this.dropdowns.sub3category.value) {
							this.formItems.sub3CategoryId = category.id;
							this.formItems.sub3CategoryName = category.name;
						}
					});
					if (this.$can('list', 'search by keyword')) {
						this.formItems.mxikCodeId = this.dropdowns.mxik.value.id
						this.formItems.mxikCode = this.dropdowns.mxik.value.mxikCode
					}
					if (this.dropdowns.colors.value) {
						this.formItems.colorId = this.dropdowns.colors.value.id;
						this.formItems.color = this.dropdowns.colors.value.code;
						this.formItems.colorName = this.dropdowns.colors.value.name;
					}

					this.dropdowns.sizesByType.items.filter((size) => {
						if (size.id === this.dropdowns.sizesByType.value) {
							this.formItems.sizeId = size.id;
							this.formItems.sizeCode = size.code;
							this.formItems.sizeName = size.name;
						}
					});

					// this.dropdowns.contragent.items.filter((contragent) => {
					// 	this.formItems.contragents.push(contragent);
					// });

					if (this.formItems.minMaxValues && this.formItems.minMaxValues.length === 1 && !this.formItems.minMaxValues[0].depId) {
						this.formItems.minMaxValues = []
					}
					if (this.multiBarcodes.length === 1 && this.multiBarcodes[0].barcode === '') {
						this.formItems.multiBarcodes = []
					} else {
						this.formItems.multiBarcodes = this.multiBarcodes
					}
					if (this.mode === 'create' || this.mode === 'duplicate') {
						GoodsService.storeGood(this.formItems).then(response => {
							this.$emit('success', true);
						}).catch(e => {
							let response = JSON.parse(e.request.response);
							this.$vs.notify({
								title: this.$t('words.error'),
								text: response.message,
								color: 'danger',
								icon: 'close',
								position: 'top-right'
							})
						});
					} else {
						delete this.formItems.popover;
						this.intAmount();
						GoodsService.updateItem(this.formItems.id, this.formItems).then(response => {
							this.$emit('success', true);
						}).catch(e => {
							let response = JSON.parse(e.request.response);
							this.$vs.notify({
								title: this.$t('words.error'),
								text: response.message,
								color: 'danger',
								icon: 'close',
								position: 'top-right'
							})
						});
					}
				} else {
					Object.keys(this.validationFields).some(key => {
						this.validationFields[key].touched = true;
						this.validationFields[key].dirty = true;
						this.validationFields[key].changed = true;
					});

					this.$vs.notify({
						title: this.$t('words.error'),
						text: 'Заполните все обязательное поле!',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				}
			});
			return false;


		},
		intAmount() {
			if (this.formItems.wrapped && this.formItems.wrappedItems.length > 0) {
				this.formItems.wrappedItems.map(item => {
					item.amount = parseInt(item.amount);
				})
			}
		},
		contragentSelectedOption(contragent) {
			return contragent.fullName
		},
		loadGroups() {
			ReferencesService.getReferenceChildren(`item_group`).then(response => {
				this.dropdowns.group.items = response.data;
			})
		},
		async loadSubCategory(id) {
			await ReferencesService.getSubReferenceChildren(id).then(response => {
				this.dropdowns.subcategory.items = response.data;
			})
		},
		async loadSubSubCategory(id) {
			await ReferencesService.getSubReferenceChildren(id).then(response => {
				this.dropdowns.subsubcategory.items = response.data;
			})
		},
		async loadSub3Category(id) {
			await ReferencesService.getSubReferenceChildren(id).then(response => {
				this.dropdowns.sub3category.items = response.data;
			})
		},
		loadBrands() {
			ReferencesService.getReferenceChildren(`item_brand`).then(response => {
				this.dropdowns.brands.items = response.data;
			})
		},
		loadSizeTypes() {
			ReferencesService.getReferenceChildren(`size_types`).then(response => {
				this.dropdowns.sizeTypes.items = response.data;
			}).catch(error => {
			})
		},
		loadSizesByType(sizeTypeId) {
			ReferencesService.getSubReferenceChildren(sizeTypeId).then(response => {
				this.dropdowns.sizesByType.items = response.data;
			}).catch(error => {
			})
		},
		async loadColors() {
			let response = await ReferencesService.getReferenceChildren(`color`);
			this.dropdowns.colors.items = response.data;
		},
		async loadMxikCode(keyword = '') {
			await ReferencesService.getMxikCodeList(keyword).then(res => {
				this.dropdowns.mxik.items = res.data
			})
		},
		loadContragents() {
			ContrAgentService.search({
				page: 1, limit: 700
			}).then(response => {
				this.dropdowns.contragent.items = response.data.items;
			})
		},
		removeItem($event) {
			this.formItems.wrappedItems.map((item, i) => {
				if (item.wrappedId === $event.wrappedId) {
					this.formItems.wrappedItems.splice(i, 1);
				}
			})

		},

		cancel() {
			this.$emit('close', true);
		},

		parentClose(data) {
			this.$emit('not-close', data);
		},
		/**
		 * Load Providers
		 */
		loadProviders() {
			ReferencesService.getReferenceChildren('providers').then(response => {
				this.dropdowns.providers = response.data;
			})
		},

		/**
		 * Load seasons
		 */
		loadSeasons() {
			ReferencesService.getReferenceChildren('SEASONS').then(response => {
				this.dropdowns.seasons = response.data;
			})
		},

		/**+
		 * Load genders
		 */
		loadGenders() {
			ReferencesService.getReferenceChildren('GENDER').then(response => {
				this.dropdowns.genders = response.data;
			})
		},

		/**
		 * Loadunits
		 */
		loadUnits() {

			ReferencesService.getReferenceChildren('unit').then(response => {
				this.dropdowns.units = response.data;
			})
		},

		/**
		 * Loadunits
		 */
		loadMaterials() {
			ReferencesService.getReferenceChildren('MATERIAL').then(response => {
				this.dropdowns.materials = response.data;
			})
		},

		wrappedItems($event) {
			this.formItems.wrappedItems = $event;
			this.childModal = false
		},
		setCategoryDefault() {
			if (this.mode === 'create' && this.getRefChildren.length === 1) {
				this.dropdowns.category = this.getRefChildren[0].id
				this.dropdowns.categoryCode = this.getRefChildren[0].code
			}

		},
		setDefaultValue() {
			if (this.mode === 'create') {
				if (this.companyType === 'SHOP') {
					this.getRefChildren.filter(index => {
						if (index.code === 'MAGAZIN') {
							this.dropdowns.category = index.id;
							this.wrappedSearchForm.categoryId = index.id;
							this.dropdowns.categoryCode = index.name;
							this.loadSubCategory(index.id);
						}
					})
				}
				this.formItems = this.item
			} else {
				let editObj = Object.assign({}, this.edit)
				if (editObj.mxikCodeId) {
					ReferencesService.getByMxikId(editObj.mxikCodeId).then(res => {
						this.dropdowns.mxik.value = res.data;
					})
				}
				if (this.mode === 'duplicate') {
					editObj.barcode = null;
					delete editObj.id;
				}
				editObj.minMaxValues.forEach(tmp => {
					this.departments.forEach(dep => {
						if (tmp.departmentId===dep.id)
							tmp.depId = dep
					})
				})
				this.dropdowns.category = editObj.categoryId;
				this.wrappedSearchForm.categoryId = editObj.categoryId;
				this.dropdowns.categoryCode = editObj.categoryName;
				this.loadSubCategory(editObj.categoryId);
				this.dropdowns.group.value = editObj.groupId;
				if (this.edit.subCategoryId) {
					this.dropdowns.subcategory.value = editObj.subCategoryId;
					this.wrappedSearchForm.sub = editObj.subCategoryId;
					this.dropdowns.subCategoryCode = editObj.subCategoryCode
					this.loadSubSubCategory(editObj.subCategoryId)
				}
				if (editObj.sub2CategoryId) {
					this.dropdowns.subsubcategory.value = editObj.sub2CategoryId;
					this.wrappedSearchForm.sub2 = editObj.subCategoryId;
				}
				if (editObj.sub3CategoryId) {
					this.dropdowns.sub3category.value = editObj.sub3CategoryId;
					this.wrappedSearchForm.sub3 = editObj.sub3CategoryId;
				}
				this.dropdowns.brands.value = editObj.brandId;
				this.dropdowns.sizeTypes.value = editObj.sizeTypeId;
				this.dropdowns.sizesByType.value = editObj.sizeId;
				if (!editObj.minMaxValues||editObj.minMaxValues.length===0)
					editObj.minMaxValues = [{}]
				this.formItems = editObj;
				if (this.formItems.weight) {
					this.weightKg = this.formItems.weight / 1000;
				}
				if (editObj.colorId) {
					let findColorArray = this.dropdowns.colors.items.filter(el => {
						return el.id == editObj.colorId;
					});
					if (findColorArray.length > 0) {
						this.dropdowns.colors.value = findColorArray[0];
					}
				}
				this.contragentMultple = editObj.contragents;
				if (editObj.multiBarcodes.length === 0) {
					this.multiBarcodes = [{
						barcode: '',
						ratio: 1
					}]
				} else {
					this.multiBarcodes = editObj.multiBarcodes;
				}
			}
		},

		async categorySelected() {
			await this.getReferenceChildren('WAREHOUSE_CATEGORY');
			let category = {}
			let found = false
			this.getRefChildren.filter(cat => {
				if (cat.id === this.dropdowns.category) {
					category = cat;
					found = true;
				}
			})
			if (!(this.formItems.categoryId === this.dropdowns.category) || !found) {

				// set to null category
				delete this.formItems.categoryCode;
				delete this.formItems.categoryName;
				this.wrappedSearchForm.categoryId = null;

				// set to null sub category
				this.dropdowns.subCategoryCode = null;
				this.dropdowns.subcategory.value = null;
				this.wrappedSearchForm.sub = null;
				delete this.formItems.subCategoryId;
				delete this.formItems.subCategoryCode;
				delete this.formItems.subCategoryName;

				//set to null subsub category
				this.dropdowns.subsubcategory.value = null;
				this.dropdowns.sub2CategoryCode = null
				this.wrappedSearchForm.sub2 = null;
				delete this.formItems.sub2CategoryCode;
				delete this.formItems.sub2CategoryId;
				delete this.formItems.sub2CategoryName;

				// set to null sub 3
				this.dropdowns.sub3category.value = null;
				this.wrappedSearchForm.sub3 = null;
				delete this.formItems.sub3CategoryCode;
				delete this.formItems.sub3CategoryId;
				delete this.formItems.sub3CategoryName;
			}

			this.formItems.categoryId = this.dropdowns.category
			this.dropdowns.categoryCode = category.code
			this.wrappedSearchForm.categoryId = this.dropdowns.category;
			if (this.dropdowns.category) {
				await this.loadSubCategory(this.dropdowns.category);
			}

		},
		async subCategorySelected() {
			if (this.dropdowns.category) {
				await this.loadSubCategory(this.dropdowns.category);
			}
			// await this.loadSubCategory(this.dropdowns.category);
			let category = {};
			this.dropdowns.subcategory.items.filter(cat => {
				if (cat.id === this.dropdowns.subcategory.value) {
					category = cat;
				}
			})

			if (!(this.formItems.subCategoryId === this.dropdowns.subcategory.value)) {
				// set to null sub category
				this.dropdowns.subCategoryCode = null
				this.wrappedSearchForm.sub = null;
				this.wrappedSearchForm.sub2 = null;
				this.wrappedSearchForm.sub3 = null;
				delete this.formItems.subCategoryId;
				delete this.formItems.subCategoryCode;
				delete this.formItems.subCategoryName;

				//set to null subsub category
				this.dropdowns.subsubcategory.value = null;
				this.dropdowns.sub2CategoryCode = null
				delete this.formItems.sub2CategoryCode;
				delete this.formItems.sub2CategoryId;
				delete this.formItems.sub2CategoryName;

				// set to null sub 3
				this.dropdowns.sub3category.value = null;
				delete this.formItems.sub3CategoryCode;
				delete this.formItems.sub3CategoryId;
				delete this.formItems.sub3CategoryName;
			}

			this.formItems.subCategoryId = this.dropdowns.subcategory.value;
			this.wrappedSearchForm.sub = this.dropdowns.subcategory.value;
			this.dropdowns.subCategoryCode = category.code;
			if (this.dropdowns.subcategory.value) {
				await this.loadSubSubCategory(this.dropdowns.subcategory.value);
			}

		},
		async subSubCategorySelected() {
			if (this.dropdowns.subcategory.value) {
				await this.loadSubSubCategory(this.dropdowns.subcategory.value);
			}

			let category = {}
			this.dropdowns.subsubcategory.items.filter(cat => {
				if (cat.id === this.dropdowns.subsubcategory.value) {
					category = cat;
				}
			})

			if (!(this.formItems.sub2CategoryId === this.dropdowns.subsubcategory.value)) {
				this.dropdowns.sub2CategoryCode = null
				this.wrappedSearchForm.sub2 = null;
				this.wrappedSearchForm.sub3 = null;
				delete this.formItems.sub2CategoryCode;
				delete this.formItems.sub2CategoryId;
				delete this.formItems.sub2CategoryName;

				// set to null sub 3
				this.dropdowns.sub3category.value = null;
				delete this.formItems.sub3CategoryCode;
				delete this.formItems.sub3CategoryId;
				delete this.formItems.sub3CategoryName;
			}

			this.formItems.sub2CategoryId = this.dropdowns.subsubcategory.value
			this.wrappedSearchForm.sub2 = this.dropdowns.subsubcategory.value;
			this.dropdowns.sub2CategoryCode = category.code
			if (this.dropdowns.subsubcategory.value) {
				await this.loadSub3Category(this.dropdowns.subsubcategory.value);
			}

		},
		async sub3CategorySelected() {
			let category = {}
			this.dropdowns.sub3category.items.filter(cat => {
				if (cat.id === this.dropdowns.sub3category.value) {
					category = cat;
				}
			})

			if (!(this.formItems.sub3CategoryId === this.dropdowns.sub3category.value)) {
				this.dropdowns.sub3CategoryCode = null
				this.wrappedSearchForm.sub3 = null;

				// set to null sub 3
				delete this.formItems.sub3CategoryCode;
				delete this.formItems.sub3CategoryId;
				delete this.formItems.sub3CategoryName;
			}
			this.formItems.sub3CategoryId = this.dropdowns.sub3category.value
			this.wrappedSearchForm.sub3 = this.dropdowns.sub3category.value;
			this.dropdowns.sub3CategoryCode = category.code
		},
		async sizeTypeSelected() {
			let sizeType = {}
			this.dropdowns.sizeTypes.items.filter(type => {
				if (type.id === this.dropdowns.sizeTypes.value) {
					sizeType = type;
					this.selectedSizeType = type;
				}
			})
			this.dropdowns.sizeTypeCode = sizeType.code
			// this.dropdowns.sizesByType.value = null;
			if (this.dropdowns.sizeTypes.value) {
				await this.loadSizesByType(this.dropdowns.sizeTypes.value);
			}
		},
	},

	computed: {
		...mapGetters('references', [
			'getReferences', 'getRefChildren'
		]),
		isChecked() {
			if (this.mode === 'create') {
				if (this.dropdowns.categoryCode === 'MAGAZIN') {
					this.formItems.forPos = true
					return true
				} else {
					this.formItems.forPos = false
					return false
				}
			}
		},
		formItemsColor() {
			return this.formItems.color;
		}
	},

	watch: {
		// 'contragentMultple': {
		// 	handler(newValue) {
		// 		this.formItems.contragents.push(newValue)
		// 		console.log(this.formItems)
		// 	}
		// },
		'dropdowns.category': {
			handler(newValue) {
				// if (newValue !== null) {
				this.categorySelected()
				/*} else {
					this.formItems.categoryId = null
				}*/
			}
		},
		'dropdowns.subcategory.value': {
			handler(newValue) {
				// if (newValue !== null) {
				this.subCategorySelected()
				/*} else {
					this.formItems.subCategoryId = null;
				}*/
			}
		},
		'dropdowns.subsubcategory.value': {
			handler(newValue) {
				// if (newValue !== null) {
				this.subSubCategorySelected()
				/*} else {
					this.formItems.sub2CategoryId = null
				}*/
			}
		},
		'dropdowns.sub3category.value': {
			handler(newValue) {
				// if (newValue !== null) {
				this.sub3CategorySelected()
				/*} else {
					this.sub3CategoryId = null;
				}*/
			}
		},


		'dropdowns.group.value': {
			handler(newVal) {
				if (newVal) {
					this.dropdowns.group.items.filter((category) => {
						if (category.id === this.dropdowns.group.value) {
							this.formItems.groupId = category.id;
							this.formItems.groupName = category.name;
						}
						return true;
					});
				} else {
					this.formItems.groupId = null;
					this.formItems.groupName = '';
				}
			}
		},

		'dropdowns.brands.value': {
			handler(newVal) {
				if (!newVal) {
					this.formItems.brandId = null;
					this.wrappedSearchForm.brandId = null;
					return 0;
				}
				this.dropdowns.brands.items.filter((category) => {
					if (category.id === this.dropdowns.brands.value) {
						this.formItems.brandId = category.id;
						this.wrappedSearchForm.brandId = category.id;
						this.formItems.brandName = category.name;
					}
					return true;
				});

			}
		},
		'dropdowns.sizeTypes.value': {
			handler(newVal) {
				this.dropdowns.sizesByType.value = null;
				this.sizeTypeSelected(newVal)
			}
		},
		'formItems.name': {
			handler(newValue) {
				if (newValue.length < 32 && !this.shortnameChanged) {
					this.formItems.shortName = newValue.replace(/\s+/g, '-').toLowerCase();
				}
			}
		},
		'dropdowns.colors.value': {
			handler(newVal) {
				if (!newVal) {
					this.formItems.colorId = null;
					this.wrappedSearchForm.colorId = null;
					return 0;
				}
				this.dropdowns.colors.items.filter((category) => {
					if (category.id === this.dropdowns.colors.value.id) {
						this.wrappedSearchForm.colorId = category.id;
					}
					return true;
				});

			}
		},
		'formItems.genderId': {
			handler(newVal) {
				if (!newVal) {
					this.formItems.genderId = null;
					this.wrappedSearchForm.genderId = null;
					return 0;
				}
				this.dropdowns.genders.filter((category) => {
					if (category.id === this.formItems.genderId) {
						this.wrappedSearchForm.genderId = category.id;
					}
					return true;
				});
			}
		},
		// 'formItems.color': {
		// 	handler(newValue) {
		// 		if (newValue) {
		//
		// 			this.formItems.colorId = newValue.id;
		// 			this.formItems.color = newValue;
		// 		} else {
		// 			this.formItems.colorId = null;
		// 			this.formItems.color = null;
		// 		}
		// 	},
		// 	// deep: true,
		// }
	},

	components: {
		AddChildren,
		SelectOrCreate: () => import('../../../components/SelectOrCreate'),
		AsyncInput,
		Multiselect
	}
}
</script>
<style scoped>
.filter-frame {
	margin-bottom: 20px;
}

.openDropdownFrame {
	display: flex;
	justify-content: flex-end;
	padding-bottom: 10px;
}

.slide-enter, .slide-leave-to {
	transform: scaleY(0);
}

.datetime-picker {
	width: 100%;
}
</style>
